import {
  versionListConstants,
  versionUploadConstants,
} from "../_redux-constants";
import { versionListService } from "../../_services";

function getVersionList(queryParams) {
  function getVersionListLoad() {
    return { type: versionListConstants.VERSION_LIST_LOADING };
  }
  function VersionListSuccess(data) {
    return { type: versionListConstants.VERSION_LIST_SUCCESS, data };
  }
  function VersionListFailure(error) {
    return { type: versionListConstants.VERSION_LIST_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getVersionListLoad());
    return versionListService.getVersionList(queryParams).then(
      (data) => {
        dispatch(VersionListSuccess(data));
      },
      (error) => {
        dispatch(VersionListFailure(error?.toString()));
      }
    );
  };
}

function uploadVersion(queryParams) {
  function VersionUploadLoad() {
    return { type: versionUploadConstants.VERSION_UPLOAD_LOADING };
  }
  function VersionUploadSuccess(data) {
    return { type: versionUploadConstants.VERSION_UPLOAD_SUCCESS, data };
  }
  function VersionUploadFailure(error) {
    return { type: versionUploadConstants.VERSION_UPLOAD_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(VersionUploadLoad());
    return versionListService.uploadVersion(queryParams).then(
      (data) => {
        dispatch(VersionUploadSuccess(data));
      },
      (error) => {
        dispatch(VersionUploadFailure(error?.toString()));
      }
    );
  };
}

export const versionListActions = {
  getVersionList,
  uploadVersion,
};
